import { Avatar, Head, Identity, NameHint } from '../ProfileMenu.styles';

const ProfileMenuHeader = ({
	userInitial,
	displayName,
	email,
	isSavingName,
	nameError,
	onNameChange,
	onNameBlur,
	onNameKeyDown,
	displayNameLabel,
}) => (
	<Head>
		<Avatar>{userInitial}</Avatar>
		<Identity>
			<input
				value={displayName}
				maxLength={32}
				aria-label={displayNameLabel}
				disabled={isSavingName}
				onChange={(event) => onNameChange(event.target.value)}
				onBlur={onNameBlur}
				onKeyDown={onNameKeyDown}
			/>
			{nameError && <NameHint $error>{nameError}</NameHint>}
			<span>{email || '—'}</span>
		</Identity>
	</Head>
);

export default ProfileMenuHeader;
